import ProcessApi from "../../service/ProcessService";
import DocumentApi from "../../service/DocumentService";
import GetAllLeadPartyRequest from "../../service/request/GetAllLeadPartyRequest";

export default {
  name: "AssignmentListTable",
  props: {
    showSelect: { type: Boolean, required: true }
  },
  data: function() {
    return {
      selectedProcessDefinitionCode: 0,
      maxIdOfActualProcessList:0,
      pageTitle: document.title,
      newRecordMessage: 'Yeni Kayıt',
      apiCallCount: 0,
      leadPartyNameDTOList:[],
      ringSound : '',
      operatorAlert : '',
      checkList : [],
      processIdList : [],
      alert : false,
      applicationNameItems:["Herkese Borsa", "Trade Master"],
      applicationName: null,
      applicationNameDisabled: false
    };
  },
  computed: {
    headers() {
      let headers = [
        {
          text: "",
          value: "",
          filterable: false
        },
        {
          text: this.$t("tckn"),
          value: "tckn",
          filterable: true
        },
        {
          text: this.$t("full/Name"),
          value: "fullName",
          filterable: true
        },
        {
          text: this.$t("processDefinition"),
          value: "processDefinition",
          filterable: true
        },
        {
          text: this.$t("processStartDate"),
          value: "processStartDate",
          filterable: true
        },
        {
          text: this.$t("processModifyDate"),
          value: "processModifyDate",
          filterable: true
        },
        {
          text: this.$t("resourceDescription"),
          value: "resourceDescription",
          filterable: false
        },
        {
          text: this.$t("status_"),
          value: "hasNFCPhone",
          filterable: false
        },
        {
          text: this.$t("channelInformation"),
          value: "channel",
          filterable: false,
          fixed: true
        },
        {
          text: this.$t("applicationInformation"),
          value: "applicationInformation",
        },
        {
          text: this.$t("meetingPreference"),
          value: "meetingPreference",
          filterable: false
        },
        {
          text: this.$t("appointmentDateTime"),
          value: "appointmentDateTime",
          filterable: false
        }
      ];

      if (this.showSelect) {
        headers.unshift({
          text: "",
          value: "",
          filterable: false
        });
      }

      return headers;
    },
   /*  processDefinitionCodeList: function() {
      return [
        {
          value: 0,
          text: this.$t("all")
        },
        {
          value: 1,
          text: this.$t("videocall")
        },
        {
          value: 2,
          text: this.$t("nfcandvideocall")
        },
        {
          value: 3,
          text: this.$t("selfonboarding")
        }
      ];
    }, */
  },
  created() {
    this.PAGE_TYPE = "AssignmentList";
    this.retrieveRingSound();
    this.retrieveOperatorAlertSound();
  },  
  mounted(){ 
    document.addEventListener("visibilitychange", this.visibilitychange)
  },
  beforeMount() {
    this.getAllByCurrentUserIdAndAssigneeId()
  },
  methods: {
    getData() {
      this.refreshing = true;
      const checkedItemIds = this.list.reduce(
        (a, curr) => (curr.checked ? a.concat(curr.id) : a),
        []
      );

      const getAllLeadPartyRequest = new GetAllLeadPartyRequest();
      if (this.selectedProcessDefinitionCode === 1) {
        getAllLeadPartyRequest.processDefinitionCodes = [
          "VIDEO_CALL_PROCESS_V2"
        ];
      } else if (this.selectedProcessDefinitionCode === 2) {
        getAllLeadPartyRequest.processDefinitionCodes = [
          "NFC_AND_VIDEO_PROCESS"
        ];
      } else if (this.selectedProcessDefinitionCode === 3) {
        getAllLeadPartyRequest.processDefinitionCodes = [
          "SELF_ONBOARDING_PROCESS"
        ];
      } else if (this.selectedProcessDefinitionCode === 4) {
        getAllLeadPartyRequest.processDefinitionCodes = [
          "LEAD_APPROVAL_PROCESS"
        ];
      }

      getAllLeadPartyRequest.leadPartyDTO.domainId = this.$store.getters[
        "user"
      ].domainId;
      getAllLeadPartyRequest.leadPartyDTO.tckn =
        this.searchTckn != null && this.searchTckn != ""
          ? this.searchTckn
          : null;
      getAllLeadPartyRequest.leadIds =
        this.leadIds.length > 0 ? this.leadIds : null;
      getAllLeadPartyRequest.pageSize = this.pageOptions.itemsPerPage;
      getAllLeadPartyRequest.page = this.pageOptions.page - 1;
      getAllLeadPartyRequest.currentUserId = this.$store.getters["user"].id;
      getAllLeadPartyRequest.leadPartyApplicationName = this.applicationName != null && this.applicationName != '' ? this.applicationName === 'Herkese Borsa' ? 'herkeseborsa' : 'trademaster' : null;  

      ProcessApi.listActualProcesses(
        this,
        getAllLeadPartyRequest,
        response => {
          this.list = response.content.content;
          this.totalItems = response.content.totalElements;
          this.checkPreviouslyCheckedItems(checkedItemIds);
          this.refreshing = false;
         
          //console.log("apiCallCount: " + this.apiCallCount)
          if(this.apiCallCount <= 1){
            this.apiCallCount += 1; 
            //console.log("apiCallCount: " + this.apiCallCount)
          } 
          //ringtone part:
          this.checkProcessList();
        },
        error => {
          console.log(error);
          this.refreshing = false;
        }
      );

      this.processIdList = [];
      this.list.forEach(item => {
        if(item.showVideoConference) {
          this.processIdList.push(item.processId);
        }
      })
      var isListMatch = this.processIdList.every(value => this.checkList.includes(value));
      if(!isListMatch) {
        this.playOperatorAlertSound();
        this.checkList = this.processIdList;
    }

    },
    onClickAssignToInitiator(id,taskId) {
      this.$emit("onClickAssignToInitiator", id,taskId);
    },
    onClickAssignProcess(id) {
      this.$emit("onClickAssignProcess", id);
    },
    playSound () {
      var audio = new Audio("data:audio/wav;base64," + this.ringSound);
      audio.play();
      console.log("sound played");
    },
    playOperatorAlertSound () {
      var audio = new Audio("data:audio/wav;base64," + this.operatorAlert);
      audio.play();
      console.log("video conversation alert sound played");
    },
    getModifyDate (item) {
      if (item.actualProcessTasks.length > 0) {
        if (item.actualProcessTasks[0].modifyTime == null) {
          return item.modifyTime;
        }
        return item.actualProcessTasks[0].modifyTime;
      }
      return item.modifyTime;
    },
    getAllByCurrentUserIdAndAssigneeId() {
      ProcessApi.getAllByCurrentUserIdAndAssigneeId(
        this,
        null,
        this.$store.getters["user"].id,
        this.$store.getters["user"].domainId,
        response => {
          if (response != null && response.actualProcessDTOList != null) {
            this.leadPartyNameDTOList = response.actualProcessDTOList.map(this.prepareLeadPartyNameDTO);

          }
        }
      );

    },
    prepareLeadPartyNameDTO: function (item) {
      let prepareLeadPartyNameDTO = {};
      prepareLeadPartyNameDTO.id = item.leadParty.id;
      prepareLeadPartyNameDTO.fullName = item.leadParty.fullName;
      prepareLeadPartyNameDTO.status = item.leadParty.status;
      return prepareLeadPartyNameDTO;
    },
    checkProcessList (){
      let processList = this.list;
      let idList = [];
      let maxElement;
      if(typeof processList != 'undefined'){
          if (processList.length !== 0) {
              for (const processInfo of processList) {
                idList.push(processInfo.id);  //veya: idList.push(processInfo.leadParty.id);
              }
              maxElement = Math.max(...idList);
              //console.log("new maxElement: " + maxElement);

              if (this.maxIdOfActualProcessList  >= 0){ 
                //console.log("maxIdOfActualProcessList " + this.maxIdOfActualProcessList) //todo
                if( maxElement > this.maxIdOfActualProcessList){     
                  if(this.apiCallCount > 1){
                    this.playSound();
                  }     
                  this.maxIdOfActualProcessList = maxElement;
                  this.changeTitleIfNotVisible();
                } else {
                  //console.log("There are no new processes")
                }
              } else {
                this.maxIdOfActualProcessList = maxElement;
              }
          
          } else {
              //console.log("processList empty");
          }
      } else {
          console.log("processList undefined");
      }
    },
    visibilitychange(){ //works if page active
      var isPageActive = !document.hidden;
      if(isPageActive){
        document.title = this.pageTitle;
        //console.log("came back at"+ new Date());
      }
    },
    changeTitleIfNotVisible(){ //works if page is not active
      var isPageActive = !document.hidden;
      if(!isPageActive){
        const demoClass = document.getElementsByClassName('title');
        const classTitle = demoClass[0].innerText;
        //console.log(classTitle);
        if(classTitle ==  this.$t("AuthAndVideoCallApprove")){
          document.title = this.newRecordMessage;
          //console.log("changeTitleIfNotVisible if statement: title changed");
        } else {
          //console.log("none")
        }
      }else {
        //console.log("changeTitleIfNotVisible else statement "+ new Date());
      }
    },
    retrieveRingSound() {
      DocumentApi.getRecent(
        this,
        "RING_SOUND",
        "RING_SOUND",
        "OBRS",
        response => {
          if (
            response &&
            response.documentFileWithIdDTO &&
            response.documentFileWithIdDTO.documentFileDTO
          ) {
            this.ringSound = response.documentFileWithIdDTO.documentFileDTO.base64Bytes;
          }
        },
        error => {
          console.log(error,"getRecent error");
        }
      );
   },
    retrieveOperatorAlertSound() {
      DocumentApi.getRecent(
        this,
        "OPERATOR_ALERT",
        "OPERATOR_ALERT",
        "OBRS",
        response => {
          if (
            response &&
            response.documentFileWithIdDTO &&
            response.documentFileWithIdDTO.documentFileDTO
          ) {
            this.operatorAlert = response.documentFileWithIdDTO.documentFileDTO.base64Bytes;
          }
        },
        error => {
          console.log(error,"getRecent error: operator alert");
        }
      );
  }

  }
};



// WEBPACK FOOTER //
// ./src/components/mixin/AssignmentListTable.js